import { useNavigate, useSearchParams } from 'react-router-dom';

// Map-specific URL params that should be stripped when navigating away from map views
const MAP_PARAMS = ['zoom', 'lng', 'lat', 'cluster'];

/**
 * Custom hook that wraps React Router's navigate to preserve URL parameters
 * Useful for keeping any query parameters across navigation
 * Note: Demo mode is now detected by hostname (demo.hollywoodtrucks.com), not URL params
 * Note: Map params (zoom, lng, lat, cluster) are stripped when navigating to /reports, /settings, or /dashboard
 */
export function useNavigateWithParams() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  return (to: string | number, options?: { replace?: boolean; state?: unknown }) => {
    if (typeof to === 'number') {
      // Handle navigation history (back/forward)
      navigate(to);
      return;
    }

    // Create a copy of current search params
    const newParams = new URLSearchParams(searchParams.toString());
    
    // Strip map-specific params when navigating away from map view
    const destPath = to.split('?')[0]; // Get path without any query params
    if (destPath.startsWith('/reports') || destPath.startsWith('/settings') || destPath.startsWith('/dashboard') || destPath.startsWith('/hire')) {
      MAP_PARAMS.forEach(param => newParams.delete(param));
    }

    // Build the new path with filtered params
    const paramsString = newParams.toString();
    const separator = to.includes('?') ? '&' : '?';
    const newPath = paramsString ? `${to}${separator}${paramsString}` : to;

    navigate(newPath, options);
  };
}